/** Generated by scripts/lesson_plans/export_feed_from_lessons.py — do not edit by hand. */

const EXAMPLES = {
  "french-diaspora-regions-french-diaspora-01-diaspora-communities-kp-1": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-01-diaspora-communities-kp-2": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-01-diaspora-communities-kp-3": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-01-diaspora-communities-kp-4": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-01-diaspora-communities-kp-5": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-02-radio-archives-kp-1": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-02-radio-archives-kp-2": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-02-radio-archives-kp-3": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-02-radio-archives-kp-4": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-02-radio-archives-kp-5": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-03-festival-networks-kp-1": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-03-festival-networks-kp-2": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-03-festival-networks-kp-3": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-03-festival-networks-kp-4": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-03-festival-networks-kp-5": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-04-fusion-scenes-kp-1": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-04-fusion-scenes-kp-2": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-04-fusion-scenes-kp-3": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-04-fusion-scenes-kp-4": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-04-fusion-scenes-kp-5": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-05-listening-across-borders-kp-1": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-05-listening-across-borders-kp-2": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-05-listening-across-borders-kp-3": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-05-listening-across-borders-kp-4": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "french-diaspora-regions-french-diaspora-05-listening-across-borders-kp-5": {
    "kind": "none",
    "illustrationPlan": "French-Diaspora trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  }
}

export default EXAMPLES
